import React from 'react'
import styled from 'styled-components'
import { TagWrapper } from './Tag'
import MoreButton from './MoreButton'

const TagListWrapper = styled.div`
  margin: -4px;

  ${TagWrapper} {
    margin 4px;
  }
`

class TagList extends React.Component {
  constructor(props) {
    super(props)
    const { children, limit } = props
    this.state = {
      expanded: false,
      items: limit ? children.slice(0, limit) : children,
    }
  }

  handleToggleExpand = () => {
    const { children, limit } = this.props
    const { expanded } = this.state
    this.setState({
      expanded: !expanded,
      items: !expanded ? children : children.slice(0, limit),
    })
  }

  render() {
    const { children, limit } = this.props
    const { items, expanded } = this.state
    return (
      <div>
        <TagListWrapper>{items}</TagListWrapper>

        {limit && children.length > limit && (
          <MoreButton onClick={this.handleToggleExpand}>
            <span>{expanded ? '-' : '+'}&nbsp;</span>
            <span>Show {expanded ? 'Less' : 'More'}</span>
          </MoreButton>
        )}
      </div>
    )
  }
}

TagList.defaultProps = {
  limit: false,
}

export default TagList
